module.exports = __webpack_public_path__ + "static/homepagenew-37f0f8fd9b8bfd4ce3fd1cb45aa60dfd.png";